export default __webpack_public_path__ + "static/media/CowSwap.cd89947d.png";